
import { Base } from '../base-component';

import './list-of-numbers.component.scss';

export class ListOfNumbers extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/list-of-numbers/list-of-numbers.component.ts